import { phoneNumberEntered } from "@analytics/bike/actions/mmv";
import { scrollIntoViewWrapper } from "@components/utils/utils";
import { MOBILE_NUMBER_LABEL } from "@utils/bike/bikeConstants";
import React from "react";
import { useDispatch } from "react-redux";
import { onMobileNumberEntered } from "segments/eventActions/bike/prequoteModule";
import * as Styles from "./styles";

const PhoneInput = (props: any) => {
    const { mobileNumber, mobileErrors, onMobileNumberChange } = props;
    const dispatch = useDispatch();
    return (
        <Styles.StyledBikeFormitem
            name="mobileNumber"
            value={mobileNumber}
            icon={require("@public/images/bike-policy-icon.svg?url")}
            iconAlt="Current policy icon"
            label={MOBILE_NUMBER_LABEL}
            mobilePrefix
            placeholder="Mobile number "
            error={mobileErrors}
            type={"number"}
            onChange={onMobileNumberChange}
            hideIcon
            handleBlur={() => {
                if (mobileNumber && mobileErrors === "") {
                    dispatch(
                        phoneNumberEntered({
                            phone: mobileNumber
                        })
                    );
                    dispatch(
                        onMobileNumberEntered({
                            phone: mobileNumber
                        })
                    );
                }
            }}
            onClick={() => {
                scrollIntoViewWrapper("mobileNumber", "start");
            }}
        />
    );
};

export default PhoneInput;